<template>
  <div>
    <v-flex xs12>
      <p class="mt-4" ref="title">
        <b>{{ name }}</b>
      </p>
      <div>
        <v-tabs slider-color="primary" v-model="activeTab">
          <v-tab :key="0">{{ $t('common.Search') }}</v-tab>
          <v-tab :key="1">{{ $tc('common.Tree') }}</v-tab>
          <v-tab-item>
            <v-autocomplete
              :value="value"
              @change="updateItems"
              :return-object="false"
              :multiple="true"
              dont-fill-mask-blanks
              :filter="baseStringSearch"
              hide-no-data
              hide-selected
              :items="filteredICPCList"
              :label="$t('common.Search')"
              item-text="label"
              item-value="id"
              chips
              deletable-chips
              dense
              clearable
              :menu-props="{
                closeOnClick: false,
                closeOnContentClick: false,
                openOnClick: false,
                maxHeight: $vuetify.breakpoint.smAndDown ? 170 : 300,
              }"
            />
          </v-tab-item>
          <v-tab-item>
          <v-treeview :items="filteredICPCTree" item-text="label" :open="treeOpen" dense>
            <template v-slot:prepend="{item}">
              <v-icon
                v-if="!item.children && value.includes(item.id)"
                @click="selectItem(item.id)"
              >check_box</v-icon>
              <v-icon
                v-else-if="!item.children"
                @click="selectItem(item.id)"
              >check_box_outline_blank</v-icon>
            </template>
            <template v-slot:label="{item}">
              <span @click="!item.children ? selectItem(item.id) : null">{{ item.label }}</span>
            </template>
          </v-treeview>
        </v-tab-item>
        </v-tabs>
      </div>
    </v-flex>
  </div>
</template>

<script>
import baseStringSearch from '@/utils/baseStringSearch'
import {ICPC, ICPCComponent, ICPCChapter } from '@/models/FamilyMedicine'
export default {
  props: {
    value: { type: Array, default: ()=>([])},
    name: { type: String, default: '' },
    enabledICPCComponents: {type: Array, default: ()=>([])}
  },
  data: () => ({
    activeTab: '0',
    treeOpen: [],
    filteredICPCTreeCache: [],
    icpcLength: 0
  }),
  computed: {
    filteredICPCList(){
      const icpc = ICPC.all()
      return icpc.filter( icpcItem => this.enabledICPCComponents.includes(icpcItem.componentId) )
    },
    filteredICPCTree(){
      if (ICPC.all().length > this.icpcLength){
        return this.getFilteredICPCTree()
      }
      return this.filteredICPCTreeCache
    }
  },
  methods: {
    baseStringSearch,
    selectItem(itemId){
      const items = [...this.value]
      if(items.includes(itemId)){
        items.splice(items.indexOf(itemId), 1)
      } else {
        items.push(itemId)
      }
      this.$emit('input', items)
    },
    updateItems(items){
      this.$emit('input', items)
    },
    getFilteredICPCTree(){
      // TODO: Refactor for caching
      // When this was in computed, it kept being called repeatedly, impacting performance for all logform fields
      // So it's implemented for now as a cache that relies on ICPC.all().length to check if there were changes

      const chapters = ICPCChapter.all()
      const components = ICPCComponent.query().where( component => this.enabledICPCComponents.includes(component.id)).get()
      const icpc = ICPC.all()
      const tree = []
      chapters.forEach(chapter => {
        const insertChapter = {...chapter, children: []}
        components.forEach(component => {
          const icpcItems = icpc.filter( el => el.chapterId === chapter.id && el.componentId === component.id )
          if(icpcItems.length > 0){
            const insertComp = {...component}
            insertComp.children = icpcItems
            insertChapter.children.push(insertComp)
          }
        })
        if(insertChapter.children.length > 0){
          tree.push(insertChapter)
        }
      });
      this.filteredICPCTreeCache = tree
      this.icpcLength = ICPC.all().length
      return tree
    },
  },
}
</script>

<style>
</style>